import React, { useEffect, useState } from 'react';
import ListItemText from '@material-ui/core/ListItemText';
import {
  FormControlLabel,
  makeStyles,
  Popover,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import Drawer from '@material-ui/core/Drawer';
import DataSource from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/DataSource';
import Grid from '@material-ui/core/Grid';
import BrokerageDropDown from '../../../../forms/tradeplans/quicktrade/BrokerageDropDown';
import AccountNumberDropDown from '../../../../forms/tradeplans/quicktrade/AccountNumberDropDown';
import DataSourceDropDown from '../../../../forms/tradeplans/quicktrade/DataSourceDropDown';
import QtyBasisDropDown from '../../../../forms/tradeplans/quicktrade/QtyBasisDropDown';
import WorkOrders from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/workOrders/WorkOrders';
import Instrument from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/Instrument';
import EntryTacticUserPrefs from './entrytactics/EntryTacticUserPrefs';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { StyledRadio } from '../../../../../utils/designComponents/StyledRadio';
import Checkbox from '@material-ui/core/Checkbox';
import InfoIconComponent from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/InfoIcon';
import FlattenAtMarketCloseDocs from '../../../../forms/tradeplans/documentation/FlattenAtMarketCloseDocumentation';
import RestartSettingsComponent from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/RestartSettings';
import evaluateQuotesDocs from '../../../../forms/tradeplans/documentation/evaluateQuotesDocs';
import PersistTradePlanIfValidationFilterFailComponent from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/PersistTradePlanIfValidationFilterFailComponent';
import TradePlanTitleWrapper from '../../../../atomic/formElements/tradePlanTitleWrapper/TradePlanTitleWrapper';
import ExitTacticsContainer from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/exitTacticsContainer/ExitTacticsContainer';
import { sendUserPreferences } from '../../../../../stores/websocketStore/utils/outgoingMessages/userpreferences/sendUserPreferences';
import { ApplyChangesModal } from '../applyChangesModal/ApplyChangesModal';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';

const useStyles = makeStyles((theme) => ({
  root: {
    spacing: theme.spacing(10),
    border: '1px solid',
  },
  paper: {
    width: '780px',
  },
  input: { fontSize: 10 },
}));

export default function TradePlanUserPreferencesMenu({
  userPreferences,
  receivedUserPreferences,
}) {
  const classes = useStyles();
  const [openApplyChangesModal, setOpenApplyChangesModal] = useState(false);
  const [openTpPreferences, setOpenTpPreferences] = useState(false);
  const {
    userPreferences: userPrefs,
    tradePlanConfig: { tradePlanConfig, dispatchTradePlanConfig },
    optionManagement: { tpConfigOptionManagement },
    tradePlanDefaultEntryTactics: {
      marketOrderEnabled,
      setMarketOrderEnabled,
      limitOrderEnabled,
      setLimitOrderEnabled,
      limitOrderOffsetAmount,
      setLimitOrderOffsetAmount,
      setLimitFromSetupBreakPrice,
      setSetLimitFromSetupBreakPrice,
      candleBreakEnabled,
      setCandleBreakEnabled,
      candleBreakCandleDuration,
      setCandleBreakCandleDuration,
      waitUntilCurrentCandleCloses,
      setWaitUntilCurrentCandleCloses,
      breakBy,
      setBreakBy,
      dollarStock,
      setDollarStock,
      dollarOption,
      setDollarOption,
      qtyStock,
      setQtyStock,
      qtyOption,
      setQtyOption,
    },
    exitTactics: {
      lossLimit,
      dispatchLossLimit,
      lossLimitEnabled,
      setLossLimitEnabled,
      preserveProfit,
      dispatchPreserveProfit,
      preserveProfitEnabled,
      setPreserveProfitEnabled,
      positionPriceTrail,
      dispatchPositionPriceTrail,
      positionPriceTrailEnabled,
      setPositionPriceTrailEnabled,
      underlyingPriceTrail,
      dispatchUnderlyingPriceTrail,
      underlyingPriceTrailEnabled,
      setUnderlyingPriceTrailEnabled,
      candleTrail,
      dispatchCandleTrail,
      candleTrailEnabled,
      setCandleTrailEnabled,
      grabCents,
      dispatchGrabCents,
      grabCentsEnabled,
      setGrabCentsEnabled,
      grabCentsMode,
      setGrabCentsMode,
      greenToRedCandles,
      dispatchGreenToRedCandles,
      greenToRedCandlesEnabled,
      setGreenToRedCandlesEnabled,
      greenToRedPositions,
      dispatchGreenToRedPositions,
      greenToRedPositionsEnabled,
      setGreenToRedPositionsEnabled,
      breakPrice,
      dispatchBreakPrice,
      breakPriceEnabled,
      setBreakPriceEnabled,
      positionBreakPrice,
      dispatchPositionBreakPrice,
      positionBreakPriceEnabled,
      setPositionBreakPriceEnabled,
      candleMagnitude,
      dispatchCandleMagnitude,
      candleMagnitudeEnabled,
      setCandleMagnitudeEnabled,
      ratchetBracketEnabled,
      setRatchetBracketEnabled,
      ratchetBracket,
      dispatchRatchetBracket,
      atrTrailEnabled,
      setAtrTrailEnabled,
      atrTrail,
      dispatchAtrTrail,
      mfeRetracementEnabled,
      setMfeRetracementEnabled,
      mfeRetracement,
      dispatchMfeRetracement,
      underlyingPriceExitEnabled,
      setUnderlyingPriceExitEnabled,
      underlyingPriceExit,
      dispatchUnderlyingPriceExit,
    },
    optionRadioButtons: { defaultOptionRadio, setDefaultOptionRadio },
    defaultSavedTpConfigKey: { savedConfigKey, setSavedConfigKey },
    restartSettings: { restartSettings, setRestartSettings },
  } = userPreferences;
  return (
    <>
      <ApplyChangesModal
        open={openApplyChangesModal}
        handleClose={() => {
          setOpenApplyChangesModal(false);
          setOpenTpPreferences(false);
        }}
        userPrefs={userPrefs}
      />
      <ListItem button>
        <ListItemText
          onClick={() => setOpenTpPreferences(!openTpPreferences)}
          primary="Trade Plan"
        />
      </ListItem>
      <Drawer
        disableEnforceFocus
        anchor="right"
        open={openTpPreferences}
        onClose={() => {
          setOpenApplyChangesModal(true);
        }}
        classes={{ paper: classes.paper }}
      >
        <Box style={{ padding: 10 }}>
          <Grid item container spacing={1}>
            <Grid item xs={3}>
              <BrokerageDropDown
                top={tradePlanConfig}
                dispatchTop={dispatchTradePlanConfig}
              />
            </Grid>
            <Grid item xs={3}>
              <AccountNumberDropDown
                top={tradePlanConfig}
                dispatchTop={dispatchTradePlanConfig}
              />
            </Grid>
            <Grid item xs={3}>
              <DataSourceDropDown
                dataSource={tradePlanConfig.dataSource}
                setDataSource={(value) => {
                  dispatchTradePlanConfig({ dataSource: value });
                }}
                setAccountNumber={(value) => {
                  dispatchTradePlanConfig({ accountNumber: value });
                }}
                setBrokerage={(value) => {
                  dispatchTradePlanConfig({ brokerage: value });
                }}
              />
            </Grid>
          </Grid>
          <Grid item>
            <br />
          </Grid>
          <Grid item xs={3}>
            <QtyBasisDropDown
              top={tradePlanConfig}
              dispatchTop={dispatchTradePlanConfig}
            />
          </Grid>
          <Grid item>
            <br />
          </Grid>
          <Grid item>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="stretch"
              border={1}
              {...{
                bgcolor: 'background.paper',
                m: 1,
                borderColor: 'text.primary',
              }}
            >
              <WorkOrders
                top={tradePlanConfig}
                dispatchTop={dispatchTradePlanConfig}
              />
            </Box>
          </Grid>
          <Grid item>
            <br />
          </Grid>
          <Box
            display="flex"
            flexDirection="column"
            //alignItems="stretch"
            border={1}
            padding={1}
            {...{
              bgcolor: 'background.paper',
              m: 1,
              borderColor: 'text.primary',
              //width: "100%"
            }}
          >
            <Instrument
              top={tradePlanConfig}
              dispatchTop={dispatchTradePlanConfig}
              optionsManagement={tpConfigOptionManagement}
            />
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            border={1}
            {...{
              bgcolor: 'background.paper',
              m: 1,
              borderColor: 'text.primary',
              padding: 1,
            }}
          >
            <FormControl component="radio">
              <FormLabel component="legend">default option radio</FormLabel>
              <RadioGroup
                aria-label="default option radio"
                name="default option radio"
                value={defaultOptionRadio}
                onChange={(ev) => setDefaultOptionRadio(ev.target.value)}
                row
              >
                <FormControlLabel
                  value="none"
                  control={<StyledRadio />}
                  label="none"
                />
                <FormControlLabel
                  value="all"
                  control={<StyledRadio />}
                  label="all"
                />
                <FormControlLabel
                  value="front"
                  control={<StyledRadio />}
                  label="front"
                />
              </RadioGroup>
            </FormControl>
          </Box>
          <Grid item xs={6}>
            {' '}
            <FormControl component="fieldset">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tradePlanConfig.evaluateQuotes}
                    onChange={(ev) =>
                      dispatchTradePlanConfig({
                        evaluateQuotes: ev.target.checked,
                      })
                    }
                    name="evaluateQuotes"
                  />
                }
                label={
                  <Typography style={{ fontSize: 12 }}>
                    {' '}
                    <InfoIconComponent docs={evaluateQuotesDocs} />
                    front run
                  </Typography>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <PersistTradePlanIfValidationFilterFailComponent
              top={tradePlanConfig}
              dispatchTop={dispatchTradePlanConfig}
            />
          </Grid>
          <Grid item xs={6}>
            {' '}
            <FormControl component="fieldset">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tradePlanConfig.flattenAtMarketClose}
                    onChange={(ev) =>
                      dispatchTradePlanConfig({
                        flattenAtMarketClose: ev.target.checked,
                      })
                    }
                    name="flattenAtMarketClose"
                  />
                }
                label={
                  <Typography style={{ fontSize: 12 }}>
                    {' '}
                    <InfoIconComponent docs={FlattenAtMarketCloseDocs} />
                    Flatten at market close
                  </Typography>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <RestartSettingsComponent
              restartSettings={restartSettings}
              setRestartSettings={setRestartSettings}
            />
          </Grid>
          <EntryTacticUserPrefs
            entryHooks={userPreferences['tradePlanDefaultEntryTactics']}
          />
          <TradePlanTitleWrapper title="Exit Tactics">
            <ExitTacticsContainer
              lossLimit={[
                lossLimit,
                dispatchLossLimit,
                lossLimitEnabled,
                setLossLimitEnabled,
              ]}
              preserveProfit={[
                preserveProfit,
                dispatchPreserveProfit,
                preserveProfitEnabled,
                setPreserveProfitEnabled,
              ]}
              positionPriceTrail={[
                positionPriceTrail,
                dispatchPositionPriceTrail,
                positionPriceTrailEnabled,
                setPositionPriceTrailEnabled,
              ]}
              underlyingPriceTrail={[
                underlyingPriceTrail,
                dispatchUnderlyingPriceTrail,
                underlyingPriceTrailEnabled,
                setUnderlyingPriceTrailEnabled,
              ]}
              candleTrail={[
                candleTrail,
                dispatchCandleTrail,
                candleTrailEnabled,
                setCandleTrailEnabled,
              ]}
              grabCents={[
                grabCents,
                dispatchGrabCents,
                grabCentsEnabled,
                setGrabCentsEnabled,
                grabCentsMode,
                setGrabCentsMode,
              ]}
              greenToRedCandles={[
                greenToRedCandles,
                dispatchGreenToRedCandles,
                greenToRedCandlesEnabled,
                setGreenToRedCandlesEnabled,
              ]}
              greenToRedPositions={[
                greenToRedPositions,
                dispatchGreenToRedPositions,
                greenToRedPositionsEnabled,
                setGreenToRedPositionsEnabled,
              ]}
              breakPrice={[
                breakPrice,
                dispatchBreakPrice,
                breakPriceEnabled,
                setBreakPriceEnabled,
              ]}
              positionBreakPrice={[
                positionBreakPrice,
                dispatchPositionBreakPrice,
                positionBreakPriceEnabled,
                setPositionBreakPriceEnabled,
              ]}
              candleMagnitude={[
                candleMagnitude,
                dispatchCandleMagnitude,
                candleMagnitudeEnabled,
                setCandleMagnitudeEnabled,
              ]}
              ratchetBracket={[
                ratchetBracket,
                dispatchRatchetBracket,
                ratchetBracketEnabled,
                setRatchetBracketEnabled,
              ]}
              atrTrail={[
                atrTrail,
                dispatchAtrTrail,
                atrTrailEnabled,
                setAtrTrailEnabled,
              ]}
              underlyingPriceExit={[
                underlyingPriceExit,
                dispatchUnderlyingPriceExit,
                underlyingPriceExitEnabled,
                setUnderlyingPriceExitEnabled,
              ]}
              mfeRetracement={[
                mfeRetracement,
                dispatchMfeRetracement,
                mfeRetracementEnabled,
                setMfeRetracementEnabled,
              ]}
              top={{}}
            />
          </TradePlanTitleWrapper>
        </Box>
      </Drawer>
    </>
  );
}
